<template >
  <div>
    <v-combobox
      v-model="headersComputed"
      :items="selectedHeaders"
      label="Скрытие и отображение столбцов"
      multiple
      small-chips
      :clearable="true"
      dense
      outlined
      :counter="headers.length"
      :hide-selected="true"
    >
      <template v-slot:selection="{ attrs, item, parent, selected }">
        <v-chip
          v-if="item === Object(item)"
          v-bind="attrs"
          :input-value="selected"
          label
          small
        >
          <span class="pr-2">{{ item.text }}</span>
          <v-icon small @click="parent.selectItem(item)">mdi-close</v-icon>
        </v-chip>
      </template>
    </v-combobox>
    <v-card-title>
      Пользователи
      <v-spacer></v-spacer>
      <v-text-field
        v-model="searchLogin"
        prepend-icon="mdi-cloud-search-outline"
        label="Поиск по логину"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headersComputed"
      :items="users"
      :options.sync="options"
      class="elevation-2"
      :server-items-length="usersCount"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': [5, 10, 20, 30],
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="900px" persistent scrollable>
            <template v-slot:activator="{ on }">
              <v-btn class="mb-2" small v-on="on" color="primary"
                >Создать</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" v-show="false">
                      <v-text-field
                        v-model="editedUser.id"
                        label="ID"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedUser.login"
                        label="Логин"
                        :error-messages="modelState['Login']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedUser.firstName"
                        label="Имя"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedUser.lastName"
                        label="Фамилия"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="editedUser.userRoleId"
                        :items="userRoles"
                        prepend-icon="mdi-shield-account-outline"
                        menu-props="auto"
                        hide-details
                        label="Роль"
                        single-line
                        item-text="name"
                        item-value="id"
                        :error-messages="modelState['userRoleId']"
                        @change="OnRoleChange"
                      ></v-select>
                    </v-col>
                    <!-- Собственный код РП (только отображение) -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      v-if="editedUser.userRoleId === REGIONAL_PARTNER_ROLE_ID"
                    >
                      <v-text-field
                        :value="partnerReferalCode || 'Будет сгенерирован при сохранении'"
                        label="Реферальный код партнёра"
                        readonly
                        disabled
                      ></v-text-field>
                    </v-col>

                    <!-- Код и сумма для реферала (любая другая роль) -->
                    <template v-else>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedUser.referalCode"
                          label="Реферальный код"
                          :disabled="referalLinked"
                          :error-messages="modelState['ReferalCode']"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="editedIndex > -1">
                        <v-text-field
                          v-model.number="editedUser.paymentSum"
                          label="Сумма"
                          type="number"
                          min="0"
                          :error-messages="modelState['PaymentSum']"
                        ></v-text-field>
                      </v-col>
                    </template>
                    <v-col cols="12" sm="6" md="6">
                      <v-autocomplete
                        v-model="editedUser.company"
                        :items="companies"
                        cache-items
                        :search-input.sync="searchCompanies"
                        :loading="loadingSearchCompany"
                        prepend-icon="mdi-domain"
                        label="Компания"
                        item-text="name"
                        item-value="id"
                        return-object
                        clearable
                        :error-messages="modelState['CompanyId']"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="editedUser.accessUserCities"
                        prepend-icon="mdi-city-variant-outline"
                        :items="accessUserCities"
                        :loading="loadingCompanyAccesses"
                        :no-data-text="
                          editedUser.company && editedUser.company.id
                            ? 'Отсутствуют данные'
                            : 'Сначала выберите компанию'
                        "
                        menu-props="auto"
                        label="Города"
                        single-line
                        item-text="name"
                        item-value="id"
                        return-object
                        multiple
                        :error-messages="modelState['AccessUserCities']"
                        @focus="LoadCompanyAccesses"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="editedUser.accessUserBINs"
                        prepend-icon="mdi-city-variant-outline"
                        :items="accessUserBINs"
                        :loading="loadingCompanyAccesses"
                        :no-data-text="
                          editedUser.company && editedUser.company.id
                            ? 'Отсутствуют данные'
                            : 'Сначала выберите компанию'
                        "
                        menu-props="auto"
                        label="БИНы"
                        single-line
                        item-text="bin"
                        item-value="bin"
                        return-object
                        multiple
                        :error-messages="modelState['AccessUserBINs']"
                        @focus="LoadCompanyAccesses"
                      ></v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      v-show="editedIndex !== -1"
                    >
                      <v-select
                        v-model="editedUser.accessUserFilials"
                        :items="accessUserFilials"
                        menu-props="auto"
                        label="Филиалы"
                        single-line
                        item-text="name"
                        item-value="id"
                        return-object
                        multiple
                        small-chips
                        :error-messages="modelState['AccessUserFilials']"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" v-show="editedIndex === -1">
                      <v-text-field
                        v-model="editedUser.password"
                        label="Пароль"
                        :error-messages="modelState['Password']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" v-show="editedIndex === -1">
                      <v-text-field
                        v-model="editedUser.confirmPassword"
                        label="Подтвердите пароль"
                        :error-messages="modelState['ConfirmPassword']"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="Close">Отмена</v-btn>
                <v-btn text @click="Save">Сохранить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <AccessDialog></AccessDialog>
          <ManagerDialog
            :show="managerDialog"
            :user-id="managerUserId"
            :prefill="managerPrefill"
            @close="CloseManagerDialog"
            @saved="OnManagerSaved"
          ></ManagerDialog>
        </v-toolbar>
      </template>

      <!-- <template v-slot:item.userPhones="props">
        <div
          v-for="item in props.item.userPhones"
          :key="item.phone"
          class="text-no-wrap"
        >
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                x-small
                v-if="item.phoneType.phoneTypeName == 'Home'"
                >mdi-phone-classic</v-icon
              >
            </template>
            <span>Домашний</span>
          </v-tooltip>

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                x-small
                v-if="item.phoneType.phoneTypeName == 'Mobile'"
                >mdi-cellphone</v-icon
              >
            </template>
            <span>Мобильный</span>
          </v-tooltip>

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                x-small
                v-if="item.phoneType.phoneTypeName == 'Work'"
                >mdi-phone-outgoing</v-icon
              >
            </template>
            <span>Рабочий</span>
          </v-tooltip>

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                x-small
                v-if="item.phoneType.phoneTypeName == 'Fax'"
                >mdi-printer</v-icon
              >
            </template>
            <span>Факс</span>
          </v-tooltip>
          {{ item.phone }}
        </div>
      </template> -->

      <!-- <template v-slot:item.userEmails="props">
        <div
          v-for="item in props.item.userEmails"
          :key="item.email"
          class="text-no-wrap"
        >
          <v-icon x-small>mdi-email</v-icon>
          {{ item.email }}
        </div>
      </template> -->

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="EditItem(item)">mdi-pencil</v-icon>
      </template>

      <!-- <template v-slot:item.accessUserCities="props">
        <div
          v-for="item in props.item.accessUserCities"
          :key="item.id"
          class="text-no-wrap"
        >
          <span v-if="item.city">
            <v-icon x-small>mdi-city</v-icon>
            {{ item.city.name }}
          </span>
        </div>
      </template>-->

      <!-- <template v-slot:item.accessUserBINs="props">
        <div
          v-for="item in props.item.accessUserBINs"
          :key="item.id"
          class="text-no-wrap"
        >
          <span v-if="item.bin">
            <v-icon x-small>mdi-city</v-icon>
            {{ item.bin }}
          </span>
        </div>
      </template> -->

      <template v-slot:item.userAccesses="{ item }">
        <v-icon small class="mr-2" @click="EditUserAccesses(item)"
          >mdi-pencil</v-icon
        >
      </template>

      <template v-slot:item.password="{ item }">
        <v-icon small class="mr-2" @click="OpenPasswordDialog(item)"
          >mdi-pencil</v-icon
        >
      </template>
    </v-data-table>

    <!-- Принудительная смена пароля -->
    <v-dialog v-model="passwordDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Смена пароля — {{ passwordUser.login }}</span>
        </v-card-title>

        <v-card-text>
          <v-alert type="warning" dense text>
            Пароль пользователя будет изменён принудительно, без его
            подтверждения. Старый пароль перестанет действовать.
          </v-alert>
          <v-form
            ref="passwordForm"
            lazy-validation
            @submit.prevent="ForceResetPassword"
          >
            <v-text-field
              v-model="newPassword"
              label="Новый пароль"
              prepend-icon="mdi-lock"
              :type="showNewPassword ? 'text' : 'password'"
              :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showNewPassword = !showNewPassword"
              :rules="newPasswordRules"
              :error-messages="modelState['Password']"
              autocomplete="new-password"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="ClosePasswordDialog">Отмена</v-btn>
          <v-btn
            color="error"
            :loading="passwordLoading"
            :disabled="passwordLoading"
            @click="ForceResetPassword"
            >Изменить</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    searchTimeout: null,
    loading: false,
    loadingSearchCompany: false,
    loadingCompanyAccesses: false,
    loadedCompanyId: null,
    options: {
      page: 1,
      itemsPerPage: 5,
    },
    usersCount: 0,
    modelState: {},
    userRoles: [],
    companies: [],
    REGIONAL_PARTNER_ROLE_ID: 12,
    MANAGER_ROLE_ID: 8,
    managerDialog: false,
    managerUserId: null,
    managerPrefill: {},
    partnerReferalCode: null,
    referalLinked: false,
    editedUser: {
      id: "",
      login: "",
      firstName: "",
      lastName: "",
      userRoleId: 0,
      company: {},
      companyId: 0,
      password: "",
      confirmPassword: "",
      accessUserCitiesId: [],
      accessUserBINsId: [],
      accessUserFilialsId: [],
      referalCode: null,
      paymentSum: null,
    },
    defaultUser: {
      id: "",
      login: "",
      firstName: "",
      lastName: "",
      userRoleId: 0,
      company: {},
      companyId: 0,
      accessUserCitiesId: [],
      accessUserBINsId: [],
      accessUserFilialsId: [],
      referalCode: null,
      paymentSum: null,
    },
    editedIndex: -1,
    users: [],
    dialog: false,
    searchCompanies: "",
    searchLogin: "",
    headers: [
      {
        text: "Id",
        align: "left",
        sortable: true,
        value: "id",
        showHeader: false,
        exclude: false,
      },
      {
        text: "Логин",
        align: "left",
        sortable: true,
        value: "login",
        showHeader: true,
        exclude: false,
      },
      {
        text: "Имя",
        align: "left",
        sortable: true,
        value: "firstName",
        showHeader: true,
        exclude: false,
      },
      {
        text: "Фамилия",
        align: "left",
        sortable: true,
        value: "lastName",
        showHeader: true,
        exclude: false,
      },
      {
        text: "Роль",
        align: "left",
        sortable: true,
        value: "userRoleName",
        showHeader: true,
        exclude: false,
      },
      {
        text: "Дата создания",
        align: "left",
        sortable: true,
        value: "dateCreated",
        showHeader: false,
        exclude: false,
      },
      {
        text: "Кем создано (Логин)",
        align: "left",
        sortable: true,
        value: "userCreated.login",
        showHeader: false,
        exclude: false,
      },
      {
        text: "Дата изменения",
        align: "left",
        sortable: true,
        value: "changedDate",
        showHeader: false,
        exclude: false,
      },
      {
        text: "Кем изменено (Логин)",
        align: "left",
        sortable: true,
        value: "changedUser.login",
        showHeader: false,
        exclude: false,
      },
      // {
      //   text: "Телефоны",
      //   align: "center",
      //   sortable: true,
      //   value: "userPhones",
      //   showHeader: true,
      //   exclude: false,
      // },
      // {
      //   text: "Почты",
      //   align: "center",
      //   sortable: true,
      //   value: "userEmails",
      //   showHeader: true,
      //   exclude: false,
      // },
      {
        text: "Компания",
        align: "center",
        sortable: true,
        value: "company.name",
        showHeader: true,
        exclude: false,
      },
      // {
      //   text: "Город",
      //   align: "left",
      //   sortable: true,
      //   value: "accessUserCities",
      //   showHeader: true,
      //   exclude: false,
      // },
      // {
      //   text: "БИН",
      //   align: "left",
      //   sortable: true,
      //   value: "accessUserBINs",
      //   showHeader: true,
      //   exclude: false,
      // },
      {
        text: "Изменение",
        value: "actions",
        sortable: false,
        showHeader: true,
        exclude: false,
      },
      {
        text: "Доступы",
        value: "userAccesses",
        sortable: false,
        showHeader: true,
        exclude: false,
      },
      {
        text: "Пароль",
        value: "password",
        sortable: false,
        showHeader: true,
        exclude: false,
      },
    ],
    passwordDialog: false,
    passwordUser: {},
    newPassword: "",
    showNewPassword: false,
    passwordLoading: false,
    newPasswordRules: [
      (value) => !!value || "Пожалуйста, введите пароль.",
      (value) => (value && value.length >= 5) || "Минимум 5 символов",
    ],
    accessUserCities: [],
    accessUserBINs: [],
    accessUserFilials: [],
  }),
  async mounted() {
    this.GetUserRoles();
  },
  methods: {
    GetCompanies(val) {
      this.loadingSearchCompany = true;

      let Pagination = {
        Take: `${this.options.itemsPerPage}`,
        Skip: `${(this.options.page - 1) * this.options.itemsPerPage}`,
      };

      let CompaniesSearchProperty = {
        Name: `${val ?? ""}`,
      };

      let CompaniesSearch = {
        Pagination,
        CompaniesSearchProperty,
      };

      this.$store
        .dispatch("COMPANIES", CompaniesSearch)
        .then((response) => {
          this.companies = response.result;
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loadingSearchCompany = false;
        });
    },
    async LoadCompanyAccesses() {
      const companyId = this.editedUser.company?.id;

      if (!companyId || this.loadedCompanyId === companyId) return;

      this.loadingCompanyAccesses = true;

      try {
        const company = await this.$store.dispatch('GET_COMPANY_BY_ID', companyId);

        this.accessUserCities = company.companyCities.map(x => x.city);
        this.accessUserBINs = company.companyBINs;
        this.accessUserFilials = company.companyFilials.map(x => x.filial);
        this.loadedCompanyId = companyId;
      }
      catch(error) {
        if (error.response?.data?.error) {
          this.$store.commit("SET_SNACKBAR", {
            text: error.response.data.error,
            timeout: 5000,
            color: "error",
            show: true,
          });
        }
      }
      finally {
        this.loadingCompanyAccesses = false;
      }
    },
    GetUserRoles() {
      this.$store
        .dispatch("USER_ROLES")
        .then(() => {
          this.userRoles = this.$store.getters.USER_ROLES;
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    GetUsers() {
      this.loading = true;

      let Pagination = {
        Take: `${this.options.itemsPerPage}`,
        Skip: `${(this.options.page - 1) * this.options.itemsPerPage}`,
      };

      let UsersSearchProperty = {
        Login: `${this.searchLogin ?? ""}`,
      };

      let UsersSearch = {
        Pagination,
        UsersSearchProperty,
      };

      this.$store
        .dispatch("USERS", UsersSearch)
        .then((response) => {
          this.loading = false;
          this.users = response.result;
          this.usersCount = response.count;
          window.console.log('USERS', this.users);
        })
        .catch((error) => {
          this.loading = false;
          window.console.log(error);
        });
    },
    async EditItem(item) {
      if (item.userRoleId === this.MANAGER_ROLE_ID) {
        this.managerUserId = item.id;
        this.managerDialog = true;
        return;
      }

      this.editedIndex = this.users.indexOf(item);
      this.editedUser = Object.assign({}, item);
      this.companies.push(this.editedUser.company);

      try{
        const data = await this.$store.dispatch('GET_BY_ID_FOR_EDIT', item.id);
  
        this.editedUser.accessUserCities = data.accessesCities;
        this.editedUser.accessUserFilials =  data.accessesFilials;
        this.editedUser.accessUserBINs = data.accessesBINs;

        this.$store.dispatch("GET_REFERAL_INFO_BY_USER", item.id).then((info) => {
          this.partnerReferalCode = info.partnerReferalCode;
          this.$set(this.editedUser, "referalCode", info.referalCode);
          this.$set(this.editedUser, "paymentSum", info.paymentSum);
          this.referalLinked = info.isLinked;
        }).catch((err) => window.console.log(err));

        this.dialog = true;
      }
      catch(error) {
        if (error.response?.data?.error) {
          this.$store.commit("SET_SNACKBAR", {
            text: error.response.data.error,
            timeout: 5000,
            color: "error",
            show: true,
          });
        }
     }
    },
    EditUserAccesses(item) {
      this.$store
        .dispatch("GET_USER_TEMPLATES", item.id)
        .then()
        .catch((error) => {
          window.console.log(error);
        });

      this.$store
        .dispatch("GET_USER_PENDING_TEMPLATES", item.id)
        .then()
        .catch((error) => {
          window.console.log(error);
        });

      this.$store
        .dispatch("ANOTHER_USER_ACTIONS_BY_ID", item.id)
        .then(() => {
          let AccessDialog = {
            show: true,
            userId: item.id,
            login: item.login,
            firstName: item.firstName,
            lastName: item.lastName,
          };
          this.$store.commit("SET_ACCESS_DIALOG", AccessDialog);
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    OpenPasswordDialog(item) {
      this.passwordUser = item;
      this.newPassword = "";
      this.showNewPassword = false;
      this.modelState = {};
      this.passwordDialog = true;
      this.$nextTick(() => {
        this.$refs.passwordForm?.resetValidation();
      });
    },
    ClosePasswordDialog() {
      this.passwordDialog = false;
      this.newPassword = "";
      this.showNewPassword = false;
      this.modelState = {};
      this.passwordUser = {};
    },
    ForceResetPassword() {
      if (!this.$refs.passwordForm.validate()) return;

      this.passwordLoading = true;
      this.$store
        .dispatch("FORCE_RESET_PASSWORD", {
          userId: this.passwordUser.id,
          password: this.newPassword,
        })
        .then(() => {
          const login = this.passwordUser.login;
          this.ClosePasswordDialog();
          this.$store.commit("SET_SNACKBAR", {
            text: `<span style="color:#D32F2F">Пароль пользователя ${login} изменён!</span>`,
            timeout: 5000,
            color: "white",
            show: true,
          });
        })
        .catch((error) => {
          if (error.response?.data?.errors) {
            this.modelState = error.response.data.errors;
          } else if (error.response?.data?.error) {
            this.$store.commit("SET_SNACKBAR", {
              text: error.response.data.error,
              timeout: 5000,
              color: "error",
              show: true,
            });
          }
        })
        .finally(() => {
          this.passwordLoading = false;
        });
    },
    Close() {
      this.modelState = {};
      this.dialog = false;
      this.$nextTick(() => {
        this.editedUser = Object.assign({}, this.defaultUser);
        this.editedIndex = -1;
        this.partnerReferalCode = null;
        this.referalLinked = false;
        this.loadedCompanyId = null;
        this.accessUserCities = [];
        this.accessUserBINs = [];
        this.accessUserFilials = [];
      });
    },
    CloseManagerDialog() {
      this.managerDialog = false;
      this.managerUserId = null;
      this.managerPrefill = {};
    },
    OnManagerSaved() {
      this.CloseManagerDialog();
      this.GetUsers();
    },
    OnRoleChange() {
      if (
        this.editedUser.userRoleId === this.MANAGER_ROLE_ID &&
        this.editedIndex === -1
      ) {
        this.managerPrefill = {
          login: this.editedUser.login,
          firstName: this.editedUser.firstName,
          lastName: this.editedUser.lastName,
        };
        this.managerUserId = null;
        this.dialog = false; // watcher dialog() вызовет Close() и сбросит editedUser — prefill уже скопирован
        this.managerDialog = true;
        return;
      }

      if (this.editedUser.userRoleId === this.REGIONAL_PARTNER_ROLE_ID) {
        this.$set(this.editedUser, "referalCode", null);
        this.$set(this.editedUser, "paymentSum", null);
      }
    },
    Save() {
      if (this.editedUser.paymentSum === "" || this.editedUser.paymentSum === undefined) {
        this.editedUser.paymentSum = null;
      }
      if (this.editedUser.referalCode === "") {
        this.editedUser.referalCode = null;
      }
      if (this.editedUser.userRoleId === this.REGIONAL_PARTNER_ROLE_ID) {
        this.editedUser.paymentSum = null;
        this.editedUser.referalCode = null;
      }

      const payload = {
        ...this.editedUser,
          accessUserCitiesId: (this.editedUser.accessUserCities || []).map(x => x?.id),
          accessUserBINsId: (this.editedUser.accessUserBINs || []).map(x => x.bin),
          accessUserFilialsId: (this.editedUser.accessUserFilials || []).map(x => x?.id),
          companyId: this.editedUser.company?.id
      }

      if (this.editedIndex > -1) {
        this.$store
          .dispatch("UPDATE_USER", payload)
          .then(() => {
            Object.assign(this.users[this.editedIndex], this.editedUser);
            this.Close();
            this.$store.commit('SET_SNACKBAR', {
              text: 'Пользователь успешно обновлен!',
              timeout: 5000,
              color: 'success',
              show: true,
            });
          })
          .catch((error) => {
            if (error.response?.data?.errors) {
              this.modelState = error.response.data.errors;
            }
            window.console.log(error);
          });
      } else {
        this.$store
          .dispatch("CREATE_USER", payload)
          .then((response) => {
            window.console.log("createStatus", response);
            this.Close();
          })
          .catch((error) => {
            if (error.response.data.errors) {
              this.modelState = error.response.data.errors;
            }
            window.console.log(error);
          });
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.GetUsers();
      },
      deep: true,
    },
      searchLogin() {
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        if (this.options.page !== 1) {
          this.options.page = 1;
        } else {
          this.GetUsers();
        }
      }, 500);
    },
    dialog(val) {
      val || this.Close();
    },
    contentUpdate() {
      this.GetUsers();
    },
    async editedUser(val) {
      if (!val.company.id) return;

      try{
        const company = await this.$store.dispatch('GET_COMPANY_BY_ID', val.company.id);

        this.accessUserCities = company.companyCities.map(x => x.city);
        this.accessUserBINs = company.companyBINs;
        this.accessUserFilials = company.companyFilials.map(x => x.filial);
        this.loadedCompanyId = val.company.id;
      }
      catch(error) {
        if (error.response?.data?.error) {
          this.$store.commit("SET_SNACKBAR", {
            text: error.response.data.error,
            timeout: 5000,
            color: "error",
            show: true,
          });
        }
     }
    },
    searchCompanies(val) {
      val && val !== this.editedUser.companyId && this.GetCompanies(val);
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Новый" : "Редактировать";
    },
    contentUpdate() {
      return this.$store.getters.CONTENT_UPDATE;
    },
    canForceResetPassword() {
      const roleName = this.$store.getters.USER?.userRole?.name;
      return roleName === "Programmer" || roleName === "Manager";
    },
    selectedHeaders: {
      get: function () {
        return this.headers
          .filter((x) => x.exclude == false)
          .filter((x) => x.value !== "password" || this.canForceResetPassword);
      },
    },
    headersComputed: {
      get: function () {
        return this.headers
          .filter((x) => x.showHeader == true)
          .filter((x) => x.exclude == false)
          .filter((x) => x.value !== "password" || this.canForceResetPassword);
      },
      set: function (val) {
        val.forEach(function (header) {
          header.showHeader = true;
        });

        this.headers.forEach(function (header) {
          if (!val.map((x) => x.text).includes(header.text))
            header.showHeader = false;
        });
      },
    },
  },
};
</script>